import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBlankPagePortrait: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBlankPagePortrait"><Path d="M4.5 21.5V2.5H19.5V15.6944V16.0714C19.5 16.8545 19.2433 17.6164 18.7685 18.2429C17.2143 20.2933 14.7751 21.5 12.1847 21.5H5.47983H4.5Z" stroke="currentColor"/><Path d="M19.5006 15.6943C19.5006 18.3332 15.7668 18.3332 14.1666 17.2777L13.024 18.4082C11.0233 20.3878 8.30983 21.4999 5.48047 21.4999" stroke="currentColor"/></CentralIconBase>;
});

export default IconBlankPagePortrait;
